import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { VISIBLE } from 'src/constants/appConstants';

const useReportUsageScreenRenders = ({
    viewSurgeryNotes,
    usageDetailsLoading,
    orderSummaryLoading,
    discrepancyUploadLoader,
    lockLoader,
    userDetailsLoading,
    myCaseResourceType,
    reportUsageInProgress,
    isSubmitClicked,
    usageDetails,
    isPriceOverride,
    showReportPayment,
    usageOrderSubmission,
    currentActivity,
    restrictReviewScreen,
    showUnidInfoScreen,
    showORreportScreen,
    reportPaymentButtonVisibility,
    procedurePageVisibility,
    countryCode,
    isPricingInProgress,
    isProductsValidationInProgress,
    kitCodeValidationInProgress,
    usageDetailsFailureAlert,
    showSaveExitCompletionPopup,
    isLoading,
}) => {
    const showBackDrop = () => {
        return (
            (!viewSurgeryNotes && usageDetailsLoading) ||
            orderSummaryLoading ||
            discrepancyUploadLoader ||
            lockLoader ||
            userDetailsLoading ||
            (myCaseResourceType !== 'reportPayment'
                ? reportUsageInProgress && !isSubmitClicked
                : reportUsageInProgress || isLoading)
        );
    };

    const showSubHeader = () => {
        return (
            usageDetails &&
            !isPriceOverride &&
            Object.keys(usageDetails).length > 0
        );
    };

    const showProgressBar = () => {
        return (
            !isPriceOverride &&
            !showReportPayment &&
            !(
                usageOrderSubmission &&
                (usageOrderSubmission?.statusCode ||
                    usageOrderSubmission?.errorCode) &&
                usageOrderSubmission?.clickedBtn === 'submit'
            ) &&
            !isSubmitClicked &&
            restrictReviewScreen
        );
    };

    const showRecordScreen = () => {
        return (
            currentActivity === 'Record' &&
            myCaseResourceType !== 'reportPayment' &&
            restrictReviewScreen &&
            !showReportPayment
        );
    };

    const showReplenScreen = () => {
        return (
            currentActivity === 'Replen' &&
            myCaseResourceType !== 'reportPayment' &&
            restrictReviewScreen
        );
    };

    const showProcedureScreen = () => {
        return (
            (showReportPayment
                ? true
                : !showUnidInfoScreen && !showORreportScreen) &&
            restrictReviewScreen
        );
    };

    const showUnidSurgeryInfoScreen = () => {
        return showUnidInfoScreen && !showReportPayment && restrictReviewScreen;
    };
    const showSurgeryORReport = () => {
        return (
            showORreportScreen &&
            currentActivity !== 'Submit' &&
            !showReportPayment &&
            restrictReviewScreen
        );
    };
    const showReportPaymentButton = () => {
        return (
            reportPaymentButtonVisibility === VISIBLE &&
            procedurePageVisibility &&
            restrictReviewScreen &&
            currentActivity !== 'Submit' &&
            !showReportPayment &&
            countryCode != COUNTRY_CODE_JAPN
        );
    };

    const showSubmitScreen = () => {
        return (
            (usageOrderSubmission &&
                (usageOrderSubmission?.statusCode ||
                    usageOrderSubmission?.errorCode) &&
                usageOrderSubmission?.clickedBtn === 'submit') ||
            (myCaseResourceType !== 'reportPayment' &&
                (isSubmitClicked || !restrictReviewScreen))
        );
    };

    const showReviewScreen = () => {
        return (
            currentActivity === 'Submit' &&
            myCaseResourceType !== 'reportPayment' &&
            !isSubmitClicked &&
            restrictReviewScreen &&
            !(usageOrderSubmission &&
                (usageOrderSubmission?.statusCode ||
                    usageOrderSubmission?.errorCode) &&
                usageOrderSubmission?.clickedBtn === 'submit')
        );
    };

    const showSpinner = () => {
        return (
            (!viewSurgeryNotes && isPricingInProgress) ||
            isProductsValidationInProgress ||
            kitCodeValidationInProgress || 
            usageDetailsLoading || isLoading
        );
    };

    const showFooter = () => {
        return (
            !(
                usageOrderSubmission &&
                (usageOrderSubmission?.statusCode ||
                    usageOrderSubmission?.errorCode) &&
                usageOrderSubmission?.clickedBtn === 'submit'
            ) &&
            !isSubmitClicked &&
            restrictReviewScreen &&
            !viewSurgeryNotes
        );
    };

    const showWarningModel = () => {
        return (
            !viewSurgeryNotes &&
            (usageDetailsFailureAlert ||
                (showSaveExitCompletionPopup && usageOrderSubmission))
        );
    };

    return {
        showBackDrop,
        showFooter,
        showProcedureScreen,
        showProgressBar,
        showSurgeryORReport,
        showRecordScreen,
        showReplenScreen,
        showSubHeader,
        showUnidSurgeryInfoScreen,
        showReportPaymentButton,
        showSubmitScreen,
        showReviewScreen,
        showSpinner,
        showWarningModel,
    };
};

export default useReportUsageScreenRenders;
